import { createBrowserHistory } from 'history';
import { applyMiddleware, createStore } from 'redux'
import {  routerMiddleware } from 'react-router-redux'
import rootReducer from '../reducers';
import { createCycleMiddleware } from 'redux-cycles';
import Immutable from "immutable";
import {createLogger} from "redux-logger";
import { run } from '@cycle/run';
import { makeHTTPDriver } from '@cycle/http';
import main from '../cycles/cycles';
import storage from "redux-persist/es/storage";
import immutableTransform from 'redux-persist-transform-immutable';
import {persistReducer, persistStore, createMigrate} from "redux-persist";
import {migrations} from "./migrations";

export const history = createBrowserHistory();
const middleware = routerMiddleware(history);
const cycleMiddleware = createCycleMiddleware();
const { makeActionDriver, makeStateDriver } = cycleMiddleware;
const config = {
  transforms: [immutableTransform({
    blacklist: []
  })],
  key: 'rootFranchiseRankings',
  storage,
  version: 1,
  migrate: createMigrate(migrations)
};
let allMiddlewares;
let logger = createLogger({
  stateTransformer: (state) => {
    let newState = {};

    for (let i of Object.keys(state)) {
      if (Immutable.Iterable.isIterable(state[i])) {
        newState[i] = state[i].toJS();

      } else {
        newState[i] = state[i];
      }
    }
    return newState;
  }
});
if(process.env.NODE_ENV !== 'production') {

  allMiddlewares = applyMiddleware(logger, middleware, cycleMiddleware);

}else{
  allMiddlewares = applyMiddleware(middleware, cycleMiddleware);
}
const store = createStore(
  persistReducer(config, rootReducer),
  allMiddlewares
);

export const persistor = persistStore(store);

run(main, {
  ACTION: makeActionDriver(),
  STATE: makeStateDriver(),
  HTTP: makeHTTPDriver()
});
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js